export interface City {
  code: string;
  name: string;
}

export const convertCityMapToArray = (): City[] => {
  const cityList: City[] = [];
  const topCityCodes = ["0", "34", "35", "6", "7"];

  topCityCodes.forEach((cityCode) =>
    cityList.push({ code: cityCode, name: cityMap[cityCode] })
  );

  for (const cityCode in cityMap) {
    if (!topCityCodes.includes(cityCode)) {
      cityList.push({ code: cityCode, name: cityMap[cityCode] });
    }
  }

  return cityList;
};

export const cityMap: { [key: string]: string } = {
  "0": "YURTDIŞI",
  "1": "ADANA",
  "2": "ADIYAMAN",
  "3": "AFYONKARAHİSAR",
  "4": "AĞRI",
  "5": "AMASYA",
  "6": "ANKARA",
  "7": "ANTALYA",
  "8": "ARTVİN",
  "9": "AYDIN",
  "10": "BALIKESİR",
  "11": "BİLECİKK",
  "12": "BİNGÖL",
  "13": "BİTLİS",
  "14": "BOLU",
  "15": "BURDUR",
  "16": "BURSA",
  "17": "ÇANAKKALE",
  "18": "ÇANKIRI",
  "19": "ÇORUM",
  "20": "DENİZLİ",
  "21": "DİYARBAKIR",
  "22": "EDİRNE",
  "23": "ELAZIĞ",
  "24": "ERZİNCAN",
  "25": "ERZURUM",
  "26": "ESKİŞEHİR",
  "27": "GAZİANTEP",
  "28": "GİRESUN",
  "29": "GÜMÜŞHANE",
  "30": "HAKKARİ",
  "31": "HATAY",
  "32": "ISPARTA",
  "33": "MERSİN",
  "34": "İSTANBUL",
  "35": "İZMİR",
  "36": "KARS",
  "37": "KASTAMONU",
  "38": "KAYSERİ",
  "39": "KIRKLARELİ",
  "40": "KIRŞEHİR",
  "41": "KOCAELİ",
  "42": "KONYA",
  "43": "KÜTAHYA",
  "44": "MALATYA",
  "45": "MANİSA",
  "46": "KAHRAMANMARAŞ",
  "47": "MARDİN",
  "48": "MUĞLA",
  "49": "MUŞ",
  "50": "NEVŞEHİR",
  "51": "NİĞDE",
  "52": "ORDU",
  "53": "RİZE",
  "54": "SAKARYA",
  "55": "SAMSUN",
  "56": "SİİRT",
  "57": "SİNOP",
  "58": "SİVAS",
  "59": "TEKİRDAĞ",
  "60": "TOKAT",
  "61": "TRABZON",
  "62": "TUNCELİ",
  "63": "ŞANLIURFA",
  "64": "UŞAK",
  "65": "VAN",
  "66": "YOZGAT",
  "67": "ZONGULDAK",
  "68": "AKSARAY",
  "69": "BAYBURT",
  "70": "KARAMAN",
  "71": "KIRIKKALE",
  "72": "BATMAN",
  "73": "ŞIRNAK",
  "74": "BARTIN",
  "75": "ARDAHAN",
  "76": "IĞDIR",
  "77": "YALOVA",
  "78": "KARABüK",
  "79": "KİLİS",
  "80": "OSMANİYE",
  "81": "DÜZCE",
};

export const districtMap: { [key: string]: string } = {
  "0": "YURTDIŞI",
  "1101": "ABANA",
  "1102": "ACIPAYAM",
  "1103": "ADALAR",
  "1104": "SEYHAN",
  "1105": "ADIYAMAN MERKEZ",
  "1106": "ADİLCEVAZ",
  "1107": "AFŞİN",
  "1108": "AFYON MERKEZ",
  "1109": "AĞLASUN",
  "1110": "AĞIN",
  "1111": "AĞRI MERKEZ",
  "1112": "AHLAT",
  "1113": "AKÇAABAT",
  "1114": "AKÇADAĞ",
  "1115": "AKÇAKALE",
  "1116": "AKÇAKOCA",
  "1117": "AKDAĞMADENİ",
  "1118": "AKHİSAR",
  "1119": "AKKUŞ",
  "1120": "AKSARAY MERKEZ",
  "1121": "AKSEKİ",
  "1122": "AKŞEHİR",
  "1123": "AKYAZI",
  "1124": "ALACA",
  "1125": "ALAÇAM",
  "1126": "ALANYA",
  "1127": "ALAŞEHİR",
  "1128": "ALİAĞA",
  "1129": "ALMUS",
  "1130": "ALTINDAĞ",
  "1131": "ALTINÖZÜ",
  "1132": "ALTINTAŞ",
  "1133": "ALUCRA",
  "1134": "AMASYA MERKEZ",
  "1135": "ANAMUR",
  "1136": "ANDIRIN",
  "1137": "ANKARA",
  "1138": "ANTALYA MERKEZ",
  "1139": "ARABAN",
  "1140": "ARAÇ",
  "1141": "ARAKLI",
  "1142": "ARALIK",
  "1143": "ARAPGİR",
  "1144": "ARDAHAN MERKEZ",
  "1145": "ARDANUÇ",
  "1146": "ARDEŞEN",
  "1147": "ARHAVİ",
  "1148": "ARGUVAN",
  "1149": "ARPAÇAY",
  "1150": "ARSİN",
  "1151": "ARTOVA",
  "1152": "ARTVİN MERKEZ",
  "1153": "AŞKALE",
  "1154": "ATABEY",
  "1155": "AVANOS",
  "1156": "AYANCIK",
  "1157": "AYAŞ",
  "1158": "AYBASTI",
  "1159": "AYDIN MERKEZ",
  "1160": "AYVACIK",
  "1161": "AYVALIK",
  "1162": "AZDAVAY",
  "1163": "BABAESKİ",
  "1164": "BAFRA",
  "1165": "BAHÇE",
  "1166": "BAKIRKÖY",
  "1167": "BALÂ",
  "1168": "BALIKESİR MERKEZ",
  "1169": "BALYA",
  "1170": "BANAZ",
  "1171": "BANDIRMA",
  "1172": "BARTIN MERKEZ",
  "1173": "BASKİL",
  "1174": "BATMAN MERKEZ",
  "1175": "BAŞKALE",
  "1176": "BAYBURT MERKEZ",
  "1177": "BAYAT",
  "1178": "BAYINDIR",
  "1179": "BAYKAN",
  "1180": "BAYRAMİÇ",
  "1181": "BERGAMA",
  "1182": "BESNİ",
  "1183": "BEŞİKTAŞ",
  "1184": "BEŞİRİ",
  "1185": "BEYKOZ",
  "1186": "BEYOĞLU",
  "1187": "BEYPAZARI",
  "1188": "BEYŞEHİR",
  "1189": "BEYTÜŞŞEBAP",
  "1190": "BİGA",
  "1191": "BİGADİÇ",
  "1192": "BİLECİK MERKEZ",
  "1193": "BİNGÖL MERKEZ",
  "1194": "BİRECİK",
  "1195": "BİSMİL",
  "1196": "BİTLİS MERKEZ",
  "1197": "BODRUM",
  "1198": "BOĞAZLIYAN",
  "1199": "BOLU MERKEZ",
  "1200": "BOLVADİN",
  "1201": "BOR",
  "1202": "BORÇKA",
  "1203": "BORNOVA",
  "1204": "BOYABAT",
  "1205": "BOZCAADA",
  "1206": "BOZDOĞAN",
  "1207": "BOZKIR",
  "1208": "BOZKURT",
  "1209": "BOZOVA",
  "1210": "BOZÜYÜK",
  "1211": "BUCAK",
  "1212": "BULANCAK",
  "1213": "BULANIK",
  "1214": "BULDAN",
  "1215": "BURDUR MERKEZ",
  "1216": "BURHANİYE",
  "1217": "BURSA MERKEZ",
  "1218": "BÜNYAN",
  "1219": "CEYHAN",
  "1220": "CEYLANPINAR",
  "1221": "CİDE",
  "1222": "CİHANBEYLİ",
  "1223": "CİZRE",
  "1224": "ÇAL",
  "1225": "ÇAMARDI",
  "1226": "ÇAMELİ",
  "1227": "ÇAMLIDERE",
  "1228": "ÇAMLIHEMŞİN",
  "1229": "ÇAN",
  "1230": "ÇANAKKALE MERKEZ",
  "1231": "ÇANKAYA",
  "1232": "ÇANKIRI MERKEZ",
  "1233": "ÇARDAK",
  "1234": "ÇARŞAMBA",
  "1235": "ÇAT",
  "1236": "ÇATAK",
  "1237": "ÇATALCA",
  "1238": "ÇATALZEYTİN",
  "1239": "ÇAY",
  "1240": "ÇAYCUMA",
  "1241": "ÇAYELİ",
  "1242": "ÇAYIRALAN",
  "1243": "ÇAYIRLI",
  "1244": "ÇAYKARA",
  "1245": "ÇEKEREK",
  "1246": "ÇELİKHAN",
  "1247": "ÇEMİŞGEZEK",
  "1248": "ÇERKEŞ",
  "1249": "ÇERMİK",
  "1250": "ÇERKEZKÖY",
  "1251": "ÇEŞME",
  "1252": "ÇILDIR",
  "1253": "ÇINAR",
  "1254": "ÇİÇEKDAĞI",
  "1255": "ÇİFTELER",
  "1256": "ÇİNE",
  "1257": "ÇİVRİL",
  "1258": "ÇORLU",
  "1259": "ÇORUM MERKEZ",
  "1260": "ÇUBUK",
  "1261": "ÇUKURCA",
  "1262": "ÇUMRA",
  "1263": "ÇÜNGÜŞ",
  "1264": "DADAY",
  "1265": "DARENDE",
  "1266": "DATÇA",
  "1267": "DAZKIRI",
  "1268": "DELİCE",
  "1269": "DEMİRCİ",
  "1270": "DEMİRKÖY",
  "1271": "DENİZLİ MERKEZ",
  "1272": "DERELİ",
  "1273": "DERİK",
  "1274": "DERİNKUYU",
  "1275": "DEVELİ",
  "1276": "DEVREK",
  "1277": "DEVREKÂNİ",
  "1278": "DİCLE",
  "1279": "DİGOR",
  "1280": "DİKİLİ",
  "1281": "DİNAR",
  "1282": "DİVRİĞİ",
  "1283": "DİYADİN",
  "1284": "DİYARBAKIR MERKEZ",
  "1285": "DOĞANHİSAR",
  "1286": "DOĞANŞEHİR",
  "1287": "DOĞUBAYAZIT",
  "1288": "DOMANİÇ",
  "1289": "DÖRTYOL",
  "1290": "DURAĞAN",
  "1291": "DURSUNBEY",
  "1292": "DÜZCE MERKEZ",
  "1293": "ECEABAT",
  "1294": "EDREMİT",
  "1295": "EDİRNE MERKEZ",
  "1296": "EFLÂNİ",
  "1297": "EĞİRDİR",
  "1298": "ELAZIĞ MERKEZ",
  "1299": "ELBİSTAN",
  "1300": "ELDİVAN",
  "1301": "ELEŞKİRT",
  "1302": "ELMADAĞ",
  "1303": "ELMALI",
  "1304": "EMET",
  "1305": "EMİNÖNÜ",
  "1306": "EMİRDAĞ",
  "1307": "ENEZ",
  "1308": "ERBAA",
  "1309": "ERCİŞ",
  "1310": "ERDEK",
  "1311": "ERDEMLİ",
  "1312": "EREĞLİ",
  "1313": "EREĞLİ",
  "1314": "ERFELEK",
  "1315": "ERGANİ",
  "1316": "ERMENEK",
  "1317": "ERUH",
  "1318": "ERZİNCAN MERKEZ",
  "1319": "ERZURUM MERKEZ",
  "1320": "ESPİYE",
  "1321": "ESKİPAZAR",
  "1322": "ESKİŞEHİR MERKEZ",
  "1323": "EŞME",
  "1324": "EYNESİL",
  "1325": "EYÜP",
  "1326": "EZİNE",
  "1327": "FATİH",
  "1328": "FATSA",
  "1329": "FEKE",
  "1330": "FELAHİYE",
  "1331": "FETHİYE",
  "1332": "FINDIKLI",
  "1333": "FİNİKE",
  "1334": "FOÇA",
  "1335": "GAZİANTEP MERKEZ",
  "1336": "GAZİOSMANPAŞA",
  "1337": "GAZİPAŞA",
  "1338": "GEBZE",
  "1339": "GEDİZ",
  "1340": "GELİBOLU",
  "1341": "GELENDOST",
  "1342": "GEMEREK",
  "1343": "GEMLİK",
  "1344": "GENÇ",
  "1345": "GERCÜŞ",
  "1346": "GEREDE",
  "1347": "GERGER",
  "1348": "GERMENCİK",
  "1349": "GERZE",
  "1350": "GEVAŞ",
  "1351": "GEYVE",
  "1352": "GİRESUN MERKEZ",
  "1353": "GÖKSUN",
  "1354": "GÖLBAŞI",
  "1355": "GÖLCÜK",
  "1356": "GÖLE",
  "1357": "GÖLHİSAR",
  "1358": "GÖLKÖY",
  "1359": "GÖLPAZARI",
  "1360": "GÖNEN",
  "1361": "GÖRELE",
  "1362": "GÖRDES",
  "1363": "GÖYNÜCEK",
  "1364": "GÖYNÜK",
  "1365": "GÜDÜL",
  "1366": "GÜLNAR",
  "1367": "GÜLŞEHİR",
  "1368": "GÜMÜŞHACIKÖY",
  "1369": "GÜMÜŞHANE MERKEZ",
  "1370": "GÜNDOĞMUŞ",
  "1371": "GÜNEY",
  "1372": "GÜRPINAR",
  "1373": "GÜRÜN",
  "1374": "HACIBEKTAŞ",
  "1375": "HADIM",
  "1376": "HAFİK",
  "1377": "HAKKARİ MERKEZ",
  "1378": "HALFETİ",
  "1379": "HAMUR",
  "1380": "HANAK",
  "1381": "HANİ",
  "1382": "HASSA",
  "1383": "HATAY MERKEZ",
  "1384": "HAVRAN",
  "1385": "HAVSA",
  "1386": "HAVZA",
  "1387": "HAYMANA",
  "1388": "HAYRABOLU",
  "1389": "HAZRO",
  "1390": "HEKİMHAN",
  "1391": "HENDEK",
  "1392": "HINIS",
  "1393": "HİLVAN",
  "1394": "HİZAN",
  "1395": "HOPA",
  "1396": "HORASAN",
  "1397": "HOZAT",
  "1398": "IĞDIR MERKEZ",
  "1399": "ILGAZ",
  "1400": "ILGIN",
  "1401": "ISPARTA MERKEZ",
  "1402": "İÇEL MERKEZ",
  "1403": "İDİL",
  "1404": "İHSANİYE",
  "1405": "İKİZDERE",
  "1406": "İLİÇ",
  "1407": "İMRANLI",
  "1408": "GÖKÇEADA",
  "1409": "İNCESU",
  "1410": "İNEBOLU",
  "1411": "İNEGÖL",
  "1412": "İPSALA",
  "1413": "İSKENDERUN",
  "1414": "İSKİLİP",
  "1415": "İSLAHİYE",
  "1416": "İSPİR",
  "1417": "İSTANBUL MERKEZ",
  "1418": "İVRİNDİ",
  "1419": "İZMİR MERKEZ",
  "1420": "İZNİK",
  "1421": "KADIKÖY",
  "1422": "KADINHANI",
  "1423": "KADİRLİ",
  "1424": "KAĞIZMAN",
  "1425": "KAHTA",
  "1426": "KALE",
  "1427": "KALECİK",
  "1428": "KALKANDERE",
  "1429": "KAMAN",
  "1430": "KANDIRA",
  "1431": "KANGAL",
  "1432": "KARABURUN",
  "1433": "KARABÜK MERKEZ",
  "1434": "KARACABEY",
  "1435": "KARACASU",
  "1436": "KARAHALLI",
  "1437": "KARAİSALI",
  "1438": "KARAKOÇAN",
  "1439": "KARAMAN MERKEZ",
  "1440": "KARAMÜRSEL",
  "1441": "KARAPINAR",
  "1442": "KARASU",
  "1443": "KARATAŞ",
  "1444": "KARAYAZI",
  "1445": "KARGI",
  "1446": "KARLIOVA",
  "1447": "KARS MERKEZ",
  "1448": "KARŞIYAKA",
  "1449": "KARTAL",
  "1450": "KASTAMONU MERKEZ",
  "1451": "KAŞ",
  "1452": "KAVAK",
  "1453": "KAYNARCA",
  "1454": "KAYSERİ MERKEZ",
  "1455": "KEBAN",
  "1456": "KEÇİBORLU",
  "1457": "KELES",
  "1458": "KELKİT",
  "1459": "KEMAH",
  "1460": "KEMALİYE",
  "1461": "KEMALPAŞA",
  "1462": "KEPSUT",
  "1463": "KESKİN",
  "1464": "KEŞAN",
  "1465": "KEŞAP",
  "1466": "KIBRISCIK",
  "1467": "KINIK",
  "1468": "KIRIKHAN",
  "1469": "KIRIKKALE MERKEZ",
  "1470": "KIRKAĞAÇ",
  "1471": "KIRKLARELİ MERKEZ",
  "1472": "KIRŞEHİR MERKEZ",
  "1473": "KIZILCAHAMAM",
  "1474": "KIZILTEPE",
  "1475": "KİĞI",
  "1476": "KİLİS MERKEZ",
  "1477": "KİRAZ",
  "1478": "KOCAELİ MERKE",
  "1479": "KOÇARLI",
  "1480": "KOFÇAZ",
  "1481": "KONYA MERKEZ",
  "1482": "KORGAN",
  "1483": "KORKUTELİ",
  "1484": "KOYULHİSAR",
  "1485": "KOZAKLI",
  "1486": "KOZAN",
  "1487": "KOZLUK",
  "1488": "KÖYCEĞİZ",
  "1489": "KULA",
  "1490": "KULP",
  "1491": "KULU",
  "1492": "KUMLUCA",
  "1493": "KUMRU",
  "1494": "KURŞUNLU",
  "1495": "KURTALAN",
  "1496": "KURUCAŞİLE",
  "1497": "KUŞADASI",
  "1498": "KUYUCAK",
  "1499": "KÜRE",
  "1500": "KÜTAHYA MERKEZ",
  "1501": "LADİK",
  "1502": "LALAPAŞA",
  "1503": "LAPSEKİ",
  "1504": "LİCE",
  "1505": "LÜLEBURGAZ",
  "1506": "MADEN",
  "1507": "MAÇKA",
  "1508": "MAHMUDİYE",
  "1509": "MALATYA MERKEZ",
  "1510": "MALAZGİRT",
  "1511": "MALKARA",
  "1512": "MANAVGAT",
  "1513": "MANİSA MERKEZ",
  "1514": "MANYAS",
  "1515": "KAHRAMANMARAŞ MERKE",
  "1516": "MARDİN MERKEZ",
  "1517": "MARMARİS",
  "1518": "MAZGİRT",
  "1519": "MAZIDAĞI",
  "1520": "MECİTÖZÜ",
  "1521": "MENEMEN",
  "1522": "MENGEN",
  "1523": "MERİÇ",
  "1524": "MERZİFON",
  "1525": "MESUDİYE",
  "1526": "MİDYAT",
  "1527": "MİHALIÇÇIK",
  "1528": "MİLAS",
  "1529": "MUCUR",
  "1530": "MUDANYA",
  "1531": "MUDURNU",
  "1532": "MUĞLA MERKEZ",
  "1533": "MURADİYE",
  "1534": "MUŞ MERKEZ",
  "1535": "MUSTAFA KEMAL PAŞA",
  "1536": "MUT",
  "1537": "MUTKİ",
  "1538": "MURATLI",
  "1539": "NALLIHAN",
  "1540": "NARMAN",
  "1541": "NAZIMİYE",
  "1542": "NAZİLLİ",
  "1543": "NEVŞEHİR MERKEZ",
  "1544": "NİĞDE MERKEZ",
  "1545": "NİKSAR",
  "1546": "NİZİP",
  "1547": "NUSAYBİN",
  "1548": "OF",
  "1549": "OĞUZELİ",
  "1550": "OLTU",
  "1551": "OLUR",
  "1552": "ORDU MERKEZ",
  "1553": "ORHANELİ",
  "1554": "ORHANGAZİ",
  "1555": "ORTA",
  "1556": "ORTAKÖY",
  "1557": "ORTAKÖY",
  "1558": "OSMANCIK",
  "1559": "OSMANELİ",
  "1560": "OSMANİYE MERKEZ",
  "1561": "OVACIK",
  "1562": "OVACIK",
  "1563": "ÖDEMİŞ",
  "1564": "ÖMERLİ",
  "1565": "ÖZALP",
  "1566": "PALU",
  "1567": "PASİNLER",
  "1568": "PATNOS",
  "1569": "PAZAR",
  "1570": "PAZARCIK",
  "1571": "PAZARYERİ",
  "1572": "PEHLİVANKÖY",
  "1573": "PERŞEMBE",
  "1574": "PERTEK",
  "1575": "PERVARİ",
  "1576": "PINARBAŞI",
  "1577": "PINARHİSAR",
  "1578": "POLATLI",
  "1579": "POSOF",
  "1580": "POZANTI",
  "1581": "PÜLÜMÜR",
  "1582": "PÜTÜRGE",
  "1583": "REFAHİYE",
  "1584": "REŞADİYE",
  "1585": "REYHANLI",
  "1586": "RİZE MERKEZ",
  "1587": "SAFRANBOLU",
  "1588": "SAİMBEYLİ",
  "1589": "SAKARYA MERKE",
  "1590": "SALİHLİ",
  "1591": "SAMANDAĞ",
  "1592": "SAMSAT",
  "1593": "SAMSUN MERKEZ",
  "1594": "SANDIKLI",
  "1595": "SAPANCA",
  "1596": "SARAY",
  "1597": "SARAYKÖY",
  "1598": "SARAYÖNÜ",
  "1599": "SARICAKAYA",
  "1600": "SARIGÖL",
  "1601": "SARIKAMIŞ",
  "1602": "SARIKAYA",
  "1603": "SARIOĞLAN",
  "1604": "SARIYER",
  "1605": "SARIZ",
  "1606": "SARUHANLI",
  "1607": "SASON",
  "1608": "SAVAŞTEPE",
  "1609": "SAVUR",
  "1610": "SEBEN",
  "1611": "SEFERİHİSAR",
  "1612": "SELÇUK",
  "1613": "SELENDİ",
  "1614": "SELİM",
  "1615": "SENİRKENT",
  "1616": "SERİK",
  "1617": "SEYDİŞEHİR",
  "1618": "SEYİTGAZİ",
  "1619": "SINDIRGI",
  "1620": "SİİRT MERKEZ",
  "1621": "SİLİFKE",
  "1622": "SİLİVRİ",
  "1623": "SİLOPİ",
  "1624": "SİLVAN",
  "1625": "SİMAV",
  "1626": "SİNCANLI",
  "1627": "SİNOP MERKEZ",
  "1628": "SİVAS MERKEZ",
  "1629": "SİVASLI",
  "1630": "SİVEREK",
  "1631": "SİVRİCE",
  "1632": "SİVRİHİSAR",
  "1633": "SOLHAN",
  "1634": "SOMA",
  "1635": "SORGUN",
  "1636": "SÖĞÜT",
  "1637": "SÖKE",
  "1638": "SULAKYURT",
  "1639": "SULTANDAĞI",
  "1640": "SULTANHİSAR",
  "1641": "SULUOVA",
  "1642": "SUNGURLU",
  "1643": "SURUÇ",
  "1644": "SUSURLUK",
  "1645": "SUSUZ",
  "1646": "SUŞEHRİ",
  "1647": "SÜRMENE",
  "1648": "SÜTÇÜLER",
  "1649": "ŞABANÖZÜ",
  "1650": "ŞARKIŞLA",
  "1651": "ŞARKİKARAAĞAÇ",
  "1652": "ŞARKÖY",
  "1653": "ŞAVŞAT",
  "1654": "ŞEBİNKARAHİSAR",
  "1655": "ŞEFAATLİ",
  "1656": "ŞEMDİNLİ",
  "1657": "ŞENKAYA",
  "1658": "ŞEREFLİKOÇHİSAR",
  "1659": "ŞİLE",
  "1660": "ŞİRAN",
  "1661": "ŞIRNAK MERKEZ",
  "1662": "ŞİRVAN",
  "1663": "ŞİŞLİ",
  "1664": "ŞUHUT",
  "1665": "TARSUS",
  "1666": "TAŞKÖPRÜ",
  "1667": "TAŞLIÇAY",
  "1668": "TAŞOVA",
  "1669": "TATVAN",
  "1670": "TAVAS",
  "1671": "TAVŞANLI",
  "1672": "TEFENNİ",
  "1673": "TEKİRDAĞ MERKEZ",
  "1674": "TEKMAN",
  "1675": "TERCAN",
  "1676": "TERME",
  "1677": "TİRE",
  "1678": "TİREBOLU",
  "1679": "TOKAT MERKEZ",
  "1680": "TOMARZA",
  "1681": "TONYA",
  "1682": "TORBALI",
  "1683": "TORTUM",
  "1684": "TORUL",
  "1685": "TOSYA",
  "1686": "TRABZON MERKEZ",
  "1687": "TUFANBEYLİ",
  "1688": "TUNCELİ MERKEZ",
  "1689": "TURGUTLU",
  "1690": "TURHAL",
  "1691": "TUTAK",
  "1692": "TUZLUCA",
  "1693": "TÜRKELİ",
  "1694": "TÜRKOĞLU",
  "1695": "ULA",
  "1696": "ULUBEY",
  "1697": "ULUBEY",
  "1698": "ULUDERE",
  "1699": "ULUBORLU",
  "1700": "ULUKIŞLA",
  "1701": "ULUS",
  "1702": "ŞANLIURFA MERKEZ",
  "1703": "URLA",
  "1704": "UŞAK MERKEZ",
  "1705": "UZUNKÖPRÜ",
  "1706": "ÜNYE",
  "1707": "ÜRGÜP",
  "1708": "ÜSKÜDAR",
  "1709": "VAKFIKEBİR",
  "1710": "VAN MERKEZ",
  "1711": "VARTO",
  "1712": "VEZİRKÖPRÜ",
  "1713": "VİRANŞEHİR",
  "1714": "VİZE",
  "1715": "YAHYALI",
  "1716": "YALOVA MERKEZ",
  "1717": "YALVAÇ",
  "1718": "YAPRAKLI",
  "1719": "YATAĞAN",
  "1720": "YAVUZELİ",
  "1721": "YAYLADAĞI",
  "1722": "YENİCE",
  "1723": "YENİMAHALLE",
  "1724": "YENİPAZAR",
  "1725": "YENİŞEHİR",
  "1726": "YERKÖY",
  "1727": "YEŞİLHİSAR",
  "1728": "YEŞİLOVA",
  "1729": "YEŞİLYURT",
  "1730": "YIĞILCA",
  "1731": "YILDIZELİ",
  "1732": "YOMRA",
  "1733": "YOZGAT MERKEZ",
  "1734": "YUMURTALIK",
  "1735": "YUNAK",
  "1736": "YUSUFELİ",
  "1737": "YÜKSEKOVA",
  "1738": "ZARA",
  "1739": "ZEYTİNBURNU",
  "1740": "ZİLE",
  "1741": "ZONGULDAK MERKEZ",
  "1742": "DALAMAN",
  "1743": "DÜZİÇİ",
  "1744": "GÖLBAŞI",
  "1745": "KEÇİÖREN",
  "1746": "MAMAK",
  "1747": "SİNCAN",
  "1748": "YÜREĞİR",
  "1749": "ACIGÖL",
  "1750": "ADAKLI",
  "1751": "AHMETLİ",
  "1752": "AKKIŞLA",
  "1753": "AKÖREN",
  "1754": "AKPINAR",
  "1755": "AKSU",
  "1756": "AKYAKA",
  "1757": "ALADAĞ",
  "1758": "ALAPLI",
  "1759": "ALPU",
  "1760": "ALTINEKİN",
  "1761": "AMASRA",
  "1762": "ARICAK",
  "1763": "ASARCIK",
  "1764": "ASLANAPA",
  "1765": "ATKARACALAR",
  "1766": "AYDINCIK",
  "1767": "AYDINTEPE",
  "1768": "AYRANCI",
  "1769": "BABADAĞ",
  "1770": "BAHÇESARAY",
  "1771": "BAŞMAKÇI",
  "1772": "BATTALGAZİ",
  "1773": "BAYAT",
  "1774": "BEKİLLİ",
  "1775": "BEŞİKDÜZÜ",
  "1776": "BEYDAĞ",
  "1777": "BEYLİKOVA",
  "1778": "BOĞAZKALE",
  "1779": "BOZYAZI",
  "1780": "BUCA",
  "1781": "BUHARKENT",
  "1782": "BÜYÜKÇEKMECE",
  "1783": "BÜYÜKORHAN",
  "1784": "CUMAYERİ",
  "1785": "ÇAĞLIYANCERİT",
  "1786": "ÇALDIRAN",
  "1787": "DARGEÇİT",
  "1788": "DEMİRÖZÜ",
  "1789": "DEREBUCAK",
  "1790": "DUMLUPINAR",
  "1791": "EĞİL",
  "1792": "ERZİN",
  "1793": "GÖLMARMARA",
  "1794": "GÖLYAKA",
  "1795": "GÜLYALI",
  "1796": "GÜNEYSU",
  "1797": "GÜRGENTEPE",
  "1798": "GÜROYMAK",
  "1799": "HARMANCIK",
  "1800": "HARRAN",
  "1801": "HASKÖY",
  "1802": "HİSARCIK",
  "1803": "HONAZ",
  "1804": "HÜYÜK",
  "1805": "İHSANGAZİ",
  "1806": "İMAMOĞLU",
  "1807": "İNCİRLİOVA",
  "1808": "İNÖNÜ",
  "1809": "İSCEHİSAR",
  "1810": "KAĞITHANE",
  "1811": "KALE",
  "1812": "KARAÇOBAN",
  "1813": "KARAMANLI",
  "1814": "KARATAY",
  "1815": "KAZAN",
  "1816": "KEMER",
  "1817": "KIZILIRMAK",
  "1818": "KOCAALİ",
  "1819": "KONAK",
  "1820": "KOVANCILAR",
  "1821": "KÖRFEZ",
  "1822": "KÖSE",
  "1823": "KÜÇÜKÇEKMECE",
  "1824": "MARMARA",
  "1825": "MARMARAEREĞLİSİ",
  "1826": "MENDERES",
  "1827": "MERAM",
  "1828": "MURGUL",
  "1829": "NİLÜFER",
  "1830": "ONDOKUZMAYIS",
  "1831": "ORTACA",
  "1832": "OSMANGAZİ",
  "1833": "PAMUKOVA",
  "1834": "PAZAR",
  "1835": "PENDİK",
  "1836": "PINARBAŞI",
  "1837": "PİRAZİZ",
  "1838": "SALIPAZARI",
  "1839": "SELÇUKLU",
  "1840": "SERİNHİSAR",
  "1841": "ŞAHİNBEY",
  "1842": "ŞALPAZARI",
  "1843": "ŞAPHANE",
  "1844": "ŞEHİTKAMİL",
  "1845": "ŞENPAZAR",
  "1846": "TALAS",
  "1847": "TARAKLI",
  "1848": "TAŞKENT",
  "1849": "TEKKEKÖY",
  "1850": "UĞURLUDAĞ",
  "1851": "UZUNDERE",
  "1852": "ÜMRANİYE",
  "1853": "ÜZÜMLÜ",
  "1854": "YAĞLIDERE",
  "1855": "YAYLADERE",
  "1856": "YENİCE",
  "1857": "YENİPAZAR",
  "1858": "YEŞİLYURT",
  "1859": "YILDIRIM",
  "1860": "AĞAÇÖREN",
  "1861": "GÜZELYURT",
  "1862": "KÂZIMKARABEKİR",
  "1863": "KOCASİNAN",
  "1864": "MELİKGAZİ",
  "1865": "PAZARYOLU",
  "1866": "SARIYAHŞİ",
  "1867": "AĞLI",
  "1868": "AHIRLI",
  "1869": "AKÇAKENT",
  "1870": "AKINCILAR",
  "1871": "AKKÖY",
  "1872": "AKYURT",
  "1873": "ALACAKAYA",
  "1874": "ALTINYAYLA",
  "1875": "ALTINYAYLA",
  "1876": "ALTUNHİSAR",
  "1877": "AYDINCIK",
  "1878": "AYDINLAR",
  "1879": "AYVACIK",
  "1880": "BAHŞİLİ",
  "1881": "BAKLAN",
  "1882": "BALIŞEYH",
  "1883": "BAŞÇİFTLİK",
  "1884": "BAŞYAYLA",
  "1885": "BAYRAMÖREN",
  "1886": "BAYRAMPAŞA",
  "1887": "BELEN",
  "1888": "BEYAĞAÇ",
  "1889": "BOZKURT",
  "1890": "BOZTEPE",
  "1891": "ÇAMAŞ",
  "1892": "ÇAMLIYAYLA",
  "1893": "ÇAMOLUK",
  "1894": "ÇANAKÇI",
  "1895": "ÇANDIR",
  "1896": "ÇARŞIBAŞI",
  "1897": "ÇATALPINAR",
  "1898": "ÇAVDARHİSAR",
  "1899": "ÇAVDIR",
  "1900": "ÇAYBAŞI",
  "1901": "ÇELEBİ",
  "1902": "ÇELTİK",
  "1903": "ÇELTİKÇİ",
  "1904": "ÇİFTLİK",
  "1905": "ÇİLİMLİ",
  "1906": "ÇOBANLAR",
  "1907": "DERBENT",
  "1908": "DEREPAZARI",
  "1909": "DERNEKPAZARI",
  "1910": "DİKMEN",
  "1911": "DODURGA",
  "1912": "DOĞANKENT",
  "1913": "DOĞANŞAR",
  "1914": "DOĞANYOL",
  "1915": "DOĞANYURT",
  "1916": "DÖRTDİVAN",
  "1917": "DÜZKÖY",
  "1918": "EDREMİT",
  "1919": "EKİNÖZÜ",
  "1920": "EMİRGAZİ",
  "1921": "ESKİL",
  "1922": "ETİMESGUT",
  "1923": "EVCİLER",
  "1924": "EVREN",
  "1925": "FERİZLİ",
  "1926": "GÖKÇEBEY",
  "1927": "GÖLOVA",
  "1928": "GÖMEÇ",
  "1929": "GÖNEN",
  "1930": "GÜCE",
  "1931": "GÜÇLÜKONAK",
  "1932": "GÜLAĞAÇ",
  "1933": "GÜNEYSINIR",
  "1934": "GÜNYÜZÜ",
  "1935": "GÜRSU",
  "1936": "HACILAR",
  "1937": "HALKAPINAR",
  "1938": "HAMAMÖZÜ",
  "1939": "HAN",
  "1940": "HANÖNÜ",
  "1941": "HASANKEYF",
  "1942": "HAYRAT",
  "1943": "HEMŞİN",
  "1944": "HOCALAR",
  "1945": "ILICA",
  "1946": "İBRADI",
  "1947": "İKİZCE",
  "1948": "İNHİSAR",
  "1949": "İYİDERE",
  "1950": "KABADÜZ",
  "1951": "KABATAŞ",
  "1952": "KADIŞEHRİ",
  "1953": "KALE",
  "1954": "KARAKEÇİLİ",
  "1955": "KARAPÜRÇEK",
  "1956": "KARKAMIŞ",
  "1957": "KARPUZLU",
  "1958": "KAVAKLIDERE",
  "1959": "KEMER",
  "1960": "KESTEL",
  "1961": "KIZILÖREN",
  "1962": "KOCAKÖY",
  "1963": "KORGUN",
  "1964": "KORKUT",
  "1965": "KÖPRÜBAŞI",
  "1966": "KÖPRÜBAŞI",
  "1967": "KÖPRÜKÖY",
  "1968": "KÖŞK",
  "1969": "KULUNCAK",
  "1970": "KUMLU",
  "1971": "KÜRTÜN",
  "1972": "LAÇİN",
  "1973": "MİHALGAZİ",
  "1974": "NURDAĞI",
  "1975": "NURHAK",
  "1976": "OĞUZLAR",
  "1977": "OTLUKBELİ",
  "1978": "ÖZVATAN",
  "1979": "PAZARLAR",
  "1980": "SARAY",
  "1981": "SARAYDÜZÜ",
  "1982": "SARAYKENT",
  "1983": "SARIVELİLER",
  "1984": "SEYDİLER",
  "1985": "SİNCİK",
  "1986": "SÖĞÜTLÜ",
  "1987": "SULUSARAY",
  "1988": "SÜLOĞLU",
  "1989": "TUT",
  "1990": "TUZLUKÇU",
  "1991": "ULAŞ",
  "1992": "YAHŞİHAN",
  "1993": "YAKAKENT",
  "1994": "YALIHÜYÜK",
  "1995": "YAZIHAN",
  "1996": "YEDİSU",
  "1997": "YENİÇAĞA",
  "1998": "YENİFAKILI",
  "2000": "DİDİM",
  "2001": "YENİŞARBADEMLİ",
  "2002": "YEŞİLLİ",
  "2003": "AVCILAR",
  "2004": "BAĞCILAR",
  "2005": "BAHÇELİEVLER",
  "2006": "BALÇOVA",
  "2007": "ÇİĞLİ",
  "2008": "DAMAL",
  "2009": "GAZİEMİR",
  "2010": "GÜNGÖREN",
  "2011": "KARAKOYUNLU",
  "2012": "MALTEPE",
  "2013": "NARLIDERE",
  "2014": "SULTANBEYLİ",
  "2015": "TUZLA",
  "2016": "ESENLER",
  "2017": "GÜMÜŞOVA",
  "2018": "GÜZELBAHÇE",
  "2019": "ALTINOVA",
  "2020": "ARMUTLU",
  "2021": "ÇINARCIK",
  "2022": "ÇİFTLİKKÖY",
  "2023": "ELBEYLİ",
  "2024": "MUSABEYLİ",
  "2025": "POLATELİ",
  "2026": "TERMAL",
  "2027": "HASANBEYLİ",
  "2028": "SUMBAS",
  "2029": "TOPRAKKALE",
  "2030": "DERİNCE",
  "2031": "KAYNAŞLI",
  "2032": "SARIÇAM",
  "2033": "ÇUKUROVA",
  "2034": "PURSAKLAR",
  "2035": "AKSU",
  "2036": "DÖŞEMEALTI",
  "2037": "KEPEZ",
  "2038": "KONYAALTI",
  "2039": "MURATPAŞA",
  "2040": "BAĞLAR",
  "2041": "KAYAPINAR",
  "2042": "SUR",
  "2043": "YENİŞEHİR",
  "2044": "PALANDÖKEN",
  "2045": "YAKUTİYE",
  "2046": "ODUNPAZARI",
  "2047": "TEPEBAŞI",
  "2048": "ARNAVUTKÖY",
  "2049": "ATAŞEHİR",
  "2050": "BAŞAKŞEHİR",
  "2051": "BEYLİKDÜZÜ",
  "2052": "ÇEKMEKÖY",
  "2053": "ESENYURT",
  "2054": "SANCAKTEPE",
  "2055": "SULTANGAZİ",
  "2056": "BAYRAKLI",
  "2057": "KARABAĞLAR",
  "2058": "BAŞİSKELE",
  "2059": "ÇAYIROVA",
  "2060": "DARICA",
  "2061": "DİLOVASI",
  "2062": "İZMİT",
  "2063": "KARTEPE",
  "2064": "AKDENİZ",
  "2065": "MEZİTLİ",
  "2066": "TOROSLAR",
  "2067": "YENİŞEHİR",
  "2068": "ADAPAZARI",
  "2069": "ARİFİYE",
  "2070": "ERENLER",
  "2071": "SERDİVAN",
  "2072": "ATAKUM",
  "2073": "CANİK",
  "2074": "İLKADIM",
};

export const districtCityMap: { [key: string]: string } = {
  "0": "0",
  "1104": "1",
  "1219": "1",
  "1329": "1",
  "1437": "1",
  "1443": "1",
  "1486": "1",
  "1580": "1",
  "1588": "1",
  "1687": "1",
  "1734": "1",
  "1748": "1",
  "1757": "1",
  "1806": "1",
  "2032": "1",
  "2033": "1",
  "1105": "2",
  "1182": "2",
  "1246": "2",
  "1347": "2",
  "1354": "2",
  "1425": "2",
  "1592": "2",
  "1985": "2",
  "1989": "2",
  "1108": "3",
  "1200": "3",
  "1239": "3",
  "1267": "3",
  "1281": "3",
  "1306": "3",
  "1404": "3",
  "1594": "3",
  "1626": "3",
  "1639": "3",
  "1664": "3",
  "1771": "3",
  "1773": "3",
  "1809": "3",
  "1906": "3",
  "1923": "3",
  "1944": "3",
  "1961": "3",
  "1111": "4",
  "1283": "4",
  "1287": "4",
  "1301": "4",
  "1379": "4",
  "1568": "4",
  "1667": "4",
  "1691": "4",
  "1134": "5",
  "1363": "5",
  "1368": "5",
  "1524": "5",
  "1641": "5",
  "1668": "5",
  "1938": "5",
  "2034": "6",
  "1130": "6",
  "1137": "6",
  "1157": "6",
  "1167": "6",
  "1187": "6",
  "1227": "6",
  "1231": "6",
  "1260": "6",
  "1302": "6",
  "1365": "6",
  "1387": "6",
  "1427": "6",
  "1473": "6",
  "1539": "6",
  "1578": "6",
  "1658": "6",
  "1723": "6",
  "1744": "6",
  "1745": "6",
  "1746": "6",
  "1747": "6",
  "1815": "6",
  "1872": "6",
  "1922": "6",
  "1924": "6",
  "2035": "7",
  "2036": "7",
  "2037": "7",
  "2038": "7",
  "2039": "7",
  "1121": "7",
  "1126": "7",
  "1138": "7",
  "1303": "7",
  "1333": "7",
  "1337": "7",
  "1370": "7",
  "1451": "7",
  "1483": "7",
  "1492": "7",
  "1512": "7",
  "1616": "7",
  "1811": "7",
  "1946": "7",
  "1959": "7",
  "1145": "8",
  "1147": "8",
  "1152": "8",
  "1202": "8",
  "1395": "8",
  "1653": "8",
  "1736": "8",
  "1828": "8",
  "1159": "9",
  "1206": "9",
  "1256": "9",
  "1348": "9",
  "1435": "9",
  "1479": "9",
  "1497": "9",
  "1498": "9",
  "1542": "9",
  "1637": "9",
  "1640": "9",
  "1724": "9",
  "1781": "9",
  "1807": "9",
  "1957": "9",
  "1968": "9",
  "2000": "9",
  "1161": "10",
  "1168": "10",
  "1169": "10",
  "1171": "10",
  "1191": "10",
  "1216": "10",
  "1291": "10",
  "1294": "10",
  "1310": "10",
  "1360": "10",
  "1384": "10",
  "1418": "10",
  "1462": "10",
  "1514": "10",
  "1608": "10",
  "1619": "10",
  "1644": "10",
  "1824": "10",
  "1928": "10",
  "1192": "11",
  "1210": "11",
  "1359": "11",
  "1559": "11",
  "1571": "11",
  "1636": "11",
  "1857": "11",
  "1948": "11",
  "1193": "12",
  "1344": "12",
  "1446": "12",
  "1475": "12",
  "1633": "12",
  "1750": "12",
  "1855": "12",
  "1996": "12",
  "1106": "13",
  "1112": "13",
  "1196": "13",
  "1394": "13",
  "1537": "13",
  "1669": "13",
  "1798": "13",
  "1199": "14",
  "1346": "14",
  "1364": "14",
  "1466": "14",
  "1522": "14",
  "1531": "14",
  "1610": "14",
  "1916": "14",
  "1997": "14",
  "1109": "15",
  "1211": "15",
  "1215": "15",
  "1357": "15",
  "1672": "15",
  "1728": "15",
  "1813": "15",
  "1816": "15",
  "1874": "15",
  "1899": "15",
  "1903": "15",
  "1217": "16",
  "1343": "16",
  "1411": "16",
  "1420": "16",
  "1434": "16",
  "1457": "16",
  "1530": "16",
  "1535": "16",
  "1553": "16",
  "1554": "16",
  "1725": "16",
  "1783": "16",
  "1799": "16",
  "1829": "16",
  "1832": "16",
  "1859": "16",
  "1935": "16",
  "1960": "16",
  "1160": "17",
  "1180": "17",
  "1190": "17",
  "1205": "17",
  "1229": "17",
  "1230": "17",
  "1293": "17",
  "1326": "17",
  "1340": "17",
  "1408": "17",
  "1503": "17",
  "1722": "17",
  "1232": "18",
  "1248": "18",
  "1300": "18",
  "1399": "18",
  "1494": "18",
  "1555": "18",
  "1649": "18",
  "1718": "18",
  "1765": "18",
  "1817": "18",
  "1885": "18",
  "1963": "18",
  "1124": "19",
  "1177": "19",
  "1259": "19",
  "1414": "19",
  "1445": "19",
  "1520": "19",
  "1556": "19",
  "1558": "19",
  "1642": "19",
  "1778": "19",
  "1850": "19",
  "1911": "19",
  "1972": "19",
  "1976": "19",
  "1102": "20",
  "1214": "20",
  "1224": "20",
  "1226": "20",
  "1233": "20",
  "1257": "20",
  "1271": "20",
  "1371": "20",
  "1426": "20",
  "1597": "20",
  "1670": "20",
  "1769": "20",
  "1774": "20",
  "1803": "20",
  "1840": "20",
  "1871": "20",
  "1881": "20",
  "1888": "20",
  "1889": "20",
  "2040": "21",
  "2041": "21",
  "2042": "21",
  "2043": "21",
  "1195": "21",
  "1249": "21",
  "1253": "21",
  "1263": "21",
  "1278": "21",
  "1284": "21",
  "1315": "21",
  "1381": "21",
  "1389": "21",
  "1490": "21",
  "1504": "21",
  "1624": "21",
  "1791": "21",
  "1962": "21",
  "1295": "22",
  "1307": "22",
  "1385": "22",
  "1412": "22",
  "1464": "22",
  "1502": "22",
  "1523": "22",
  "1705": "22",
  "1988": "22",
  "1110": "23",
  "1173": "23",
  "1298": "23",
  "1438": "23",
  "1455": "23",
  "1506": "23",
  "1566": "23",
  "1631": "23",
  "1762": "23",
  "1820": "23",
  "1873": "23",
  "1243": "24",
  "1318": "24",
  "1406": "24",
  "1459": "24",
  "1460": "24",
  "1583": "24",
  "1675": "24",
  "1853": "24",
  "1977": "24",
  "1153": "25",
  "1235": "25",
  "1319": "25",
  "1392": "25",
  "1396": "25",
  "1416": "25",
  "1444": "25",
  "1540": "25",
  "1550": "25",
  "1551": "25",
  "1567": "25",
  "1657": "25",
  "1674": "25",
  "1683": "25",
  "1812": "25",
  "1851": "25",
  "1865": "25",
  "1945": "25",
  "1967": "25",
  "2044": "25",
  "2045": "25",
  "2046": "26",
  "2047": "26",
  "1255": "26",
  "1322": "26",
  "1508": "26",
  "1527": "26",
  "1599": "26",
  "1618": "26",
  "1632": "26",
  "1759": "26",
  "1777": "26",
  "1808": "26",
  "1934": "26",
  "1939": "26",
  "1973": "26",
  "1139": "27",
  "1335": "27",
  "1415": "27",
  "1546": "27",
  "1549": "27",
  "1720": "27",
  "1841": "27",
  "1844": "27",
  "1956": "27",
  "1974": "27",
  "1133": "28",
  "1212": "28",
  "1272": "28",
  "1320": "28",
  "1324": "28",
  "1352": "28",
  "1361": "28",
  "1465": "28",
  "1654": "28",
  "1678": "28",
  "1837": "28",
  "1854": "28",
  "1893": "28",
  "1894": "28",
  "1912": "28",
  "1930": "28",
  "1369": "29",
  "1458": "29",
  "1660": "29",
  "1684": "29",
  "1822": "29",
  "1971": "29",
  "1261": "30",
  "1377": "30",
  "1656": "30",
  "1737": "30",
  "1131": "31",
  "1289": "31",
  "1382": "31",
  "1383": "31",
  "1413": "31",
  "1468": "31",
  "1585": "31",
  "1591": "31",
  "1721": "31",
  "1792": "31",
  "1887": "31",
  "1970": "31",
  "1154": "32",
  "1297": "32",
  "1341": "32",
  "1401": "32",
  "1456": "32",
  "1615": "32",
  "1648": "32",
  "1651": "32",
  "1699": "32",
  "1717": "32",
  "1755": "32",
  "1929": "32",
  "2001": "32",
  "1135": "33",
  "1311": "33",
  "1366": "33",
  "1402": "33",
  "1536": "33",
  "1621": "33",
  "1665": "33",
  "1766": "33",
  "1779": "33",
  "1892": "33",
  "2064": "33",
  "2065": "33",
  "2066": "33",
  "2067": "33",
  "1103": "34",
  "1166": "34",
  "1183": "34",
  "1185": "34",
  "1186": "34",
  "1237": "34",
  "1305": "34",
  "1325": "34",
  "1327": "34",
  "1336": "34",
  "1417": "34",
  "1421": "34",
  "1449": "34",
  "1604": "34",
  "1622": "34",
  "1659": "34",
  "1663": "34",
  "1708": "34",
  "1739": "34",
  "1782": "34",
  "1810": "34",
  "1823": "34",
  "1835": "34",
  "1852": "34",
  "1886": "34",
  "2003": "34",
  "2004": "34",
  "2005": "34",
  "2010": "34",
  "2012": "34",
  "2014": "34",
  "2015": "34",
  "2016": "34",
  "2048": "34",
  "2049": "34",
  "2050": "34",
  "2051": "34",
  "2052": "34",
  "2053": "34",
  "2054": "34",
  "2055": "34",
  "2056": "35",
  "2057": "35",
  "1128": "35",
  "1178": "35",
  "1181": "35",
  "1203": "35",
  "1251": "35",
  "1280": "35",
  "1334": "35",
  "1419": "35",
  "1432": "35",
  "1448": "35",
  "1461": "35",
  "1467": "35",
  "1477": "35",
  "1521": "35",
  "1563": "35",
  "1611": "35",
  "1612": "35",
  "1677": "35",
  "1682": "35",
  "1703": "35",
  "1776": "35",
  "1780": "35",
  "1819": "35",
  "1826": "35",
  "2006": "35",
  "2007": "35",
  "2009": "35",
  "2013": "35",
  "2018": "35",
  "1149": "36",
  "1279": "36",
  "1424": "36",
  "1447": "36",
  "1601": "36",
  "1614": "36",
  "1645": "36",
  "1756": "36",
  "1101": "37",
  "1140": "37",
  "1162": "37",
  "1208": "37",
  "1221": "37",
  "1238": "37",
  "1264": "37",
  "1277": "37",
  "1410": "37",
  "1450": "37",
  "1499": "37",
  "1666": "37",
  "1685": "37",
  "1805": "37",
  "1836": "37",
  "1845": "37",
  "1867": "37",
  "1915": "37",
  "1940": "37",
  "1984": "37",
  "1218": "38",
  "1275": "38",
  "1330": "38",
  "1409": "38",
  "1454": "38",
  "1576": "38",
  "1603": "38",
  "1605": "38",
  "1680": "38",
  "1715": "38",
  "1727": "38",
  "1752": "38",
  "1846": "38",
  "1863": "38",
  "1864": "38",
  "1936": "38",
  "1978": "38",
  "1163": "39",
  "1270": "39",
  "1471": "39",
  "1480": "39",
  "1505": "39",
  "1572": "39",
  "1577": "39",
  "1714": "39",
  "1254": "40",
  "1429": "40",
  "1472": "40",
  "1529": "40",
  "1754": "40",
  "1869": "40",
  "1890": "40",
  "2058": "41",
  "2059": "41",
  "2060": "41",
  "2061": "41",
  "2062": "41",
  "2063": "41",
  "1338": "41",
  "1355": "41",
  "1430": "41",
  "1440": "41",
  "1478": "41",
  "1821": "41",
  "2030": "41",
  "1122": "42",
  "1188": "42",
  "1207": "42",
  "1222": "42",
  "1262": "42",
  "1285": "42",
  "1312": "42",
  "1375": "42",
  "1400": "42",
  "1422": "42",
  "1441": "42",
  "1481": "42",
  "1491": "42",
  "1598": "42",
  "1617": "42",
  "1735": "42",
  "1753": "42",
  "1760": "42",
  "1789": "42",
  "1804": "42",
  "1814": "42",
  "1827": "42",
  "1839": "42",
  "1848": "42",
  "1868": "42",
  "1902": "42",
  "1907": "42",
  "1920": "42",
  "1933": "42",
  "1937": "42",
  "1990": "42",
  "1994": "42",
  "1132": "43",
  "1288": "43",
  "1304": "43",
  "1339": "43",
  "1500": "43",
  "1625": "43",
  "1671": "43",
  "1764": "43",
  "1790": "43",
  "1802": "43",
  "1843": "43",
  "1898": "43",
  "1979": "43",
  "1114": "44",
  "1143": "44",
  "1148": "44",
  "1265": "44",
  "1286": "44",
  "1390": "44",
  "1509": "44",
  "1582": "44",
  "1729": "44",
  "1772": "44",
  "1914": "44",
  "1953": "44",
  "1969": "44",
  "1995": "44",
  "1118": "45",
  "1127": "45",
  "1269": "45",
  "1362": "45",
  "1470": "45",
  "1489": "45",
  "1513": "45",
  "1590": "45",
  "1600": "45",
  "1606": "45",
  "1613": "45",
  "1634": "45",
  "1689": "45",
  "1751": "45",
  "1793": "45",
  "1965": "45",
  "1107": "46",
  "1136": "46",
  "1299": "46",
  "1353": "46",
  "1515": "46",
  "1570": "46",
  "1694": "46",
  "1785": "46",
  "1919": "46",
  "1975": "46",
  "1273": "47",
  "1474": "47",
  "1516": "47",
  "1519": "47",
  "1526": "47",
  "1547": "47",
  "1564": "47",
  "1609": "47",
  "1787": "47",
  "2002": "47",
  "1197": "48",
  "1266": "48",
  "1331": "48",
  "1488": "48",
  "1517": "48",
  "1528": "48",
  "1532": "48",
  "1695": "48",
  "1719": "48",
  "1742": "48",
  "1831": "48",
  "1958": "48",
  "1213": "49",
  "1510": "49",
  "1534": "49",
  "1711": "49",
  "1801": "49",
  "1964": "49",
  "1155": "50",
  "1274": "50",
  "1367": "50",
  "1374": "50",
  "1485": "50",
  "1543": "50",
  "1707": "50",
  "1749": "50",
  "1201": "51",
  "1225": "51",
  "1544": "51",
  "1700": "51",
  "1876": "51",
  "1904": "51",
  "1119": "52",
  "1158": "52",
  "1328": "52",
  "1358": "52",
  "1482": "52",
  "1493": "52",
  "1525": "52",
  "1552": "52",
  "1573": "52",
  "1696": "52",
  "1706": "52",
  "1795": "52",
  "1797": "52",
  "1891": "52",
  "1897": "52",
  "1900": "52",
  "1947": "52",
  "1950": "52",
  "1951": "52",
  "1146": "53",
  "1228": "53",
  "1241": "53",
  "1332": "53",
  "1405": "53",
  "1428": "53",
  "1569": "53",
  "1586": "53",
  "1796": "53",
  "1908": "53",
  "1943": "53",
  "1949": "53",
  "1123": "54",
  "1351": "54",
  "1391": "54",
  "1442": "54",
  "1453": "54",
  "1589": "54",
  "1595": "54",
  "1818": "54",
  "1833": "54",
  "1847": "54",
  "1925": "54",
  "1955": "54",
  "1986": "54",
  "2068": "54",
  "2069": "54",
  "2070": "54",
  "2071": "54",
  "2072": "55",
  "2073": "55",
  "2074": "55",
  "1125": "55",
  "1164": "55",
  "1234": "55",
  "1386": "55",
  "1452": "55",
  "1501": "55",
  "1593": "55",
  "1676": "55",
  "1712": "55",
  "1763": "55",
  "1830": "55",
  "1838": "55",
  "1849": "55",
  "1879": "55",
  "1993": "55",
  "1179": "56",
  "1317": "56",
  "1495": "56",
  "1575": "56",
  "1620": "56",
  "1662": "56",
  "1878": "56",
  "1156": "57",
  "1204": "57",
  "1290": "57",
  "1314": "57",
  "1349": "57",
  "1627": "57",
  "1693": "57",
  "1910": "57",
  "1981": "57",
  "1282": "58",
  "1342": "58",
  "1373": "58",
  "1376": "58",
  "1407": "58",
  "1431": "58",
  "1484": "58",
  "1628": "58",
  "1646": "58",
  "1650": "58",
  "1731": "58",
  "1738": "58",
  "1870": "58",
  "1875": "58",
  "1913": "58",
  "1927": "58",
  "1991": "58",
  "1250": "59",
  "1258": "59",
  "1388": "59",
  "1511": "59",
  "1538": "59",
  "1596": "59",
  "1652": "59",
  "1673": "59",
  "1825": "59",
  "1129": "60",
  "1151": "60",
  "1308": "60",
  "1545": "60",
  "1584": "60",
  "1679": "60",
  "1690": "60",
  "1740": "60",
  "1834": "60",
  "1858": "60",
  "1883": "60",
  "1987": "60",
  "1113": "61",
  "1141": "61",
  "1150": "61",
  "1244": "61",
  "1507": "61",
  "1548": "61",
  "1647": "61",
  "1681": "61",
  "1686": "61",
  "1709": "61",
  "1732": "61",
  "1775": "61",
  "1842": "61",
  "1896": "61",
  "1909": "61",
  "1917": "61",
  "1942": "61",
  "1966": "61",
  "1247": "62",
  "1397": "62",
  "1518": "62",
  "1541": "62",
  "1562": "62",
  "1574": "62",
  "1581": "62",
  "1688": "62",
  "1115": "63",
  "1194": "63",
  "1209": "63",
  "1220": "63",
  "1378": "63",
  "1393": "63",
  "1630": "63",
  "1643": "63",
  "1702": "63",
  "1713": "63",
  "1800": "63",
  "1170": "64",
  "1323": "64",
  "1436": "64",
  "1629": "64",
  "1697": "64",
  "1704": "64",
  "1175": "65",
  "1236": "65",
  "1309": "65",
  "1350": "65",
  "1372": "65",
  "1533": "65",
  "1565": "65",
  "1710": "65",
  "1770": "65",
  "1786": "65",
  "1918": "65",
  "1980": "65",
  "1117": "66",
  "1198": "66",
  "1242": "66",
  "1245": "66",
  "1602": "66",
  "1635": "66",
  "1655": "66",
  "1726": "66",
  "1733": "66",
  "1877": "66",
  "1895": "66",
  "1952": "66",
  "1982": "66",
  "1998": "66",
  "1240": "67",
  "1276": "67",
  "1313": "67",
  "1741": "67",
  "1758": "67",
  "1926": "67",
  "1120": "68",
  "1557": "68",
  "1860": "68",
  "1861": "68",
  "1866": "68",
  "1921": "68",
  "1932": "68",
  "1176": "69",
  "1767": "69",
  "1788": "69",
  "1316": "70",
  "1439": "70",
  "1768": "70",
  "1862": "70",
  "1884": "70",
  "1983": "70",
  "1268": "71",
  "1463": "71",
  "1469": "71",
  "1638": "71",
  "1880": "71",
  "1882": "71",
  "1901": "71",
  "1954": "71",
  "1992": "71",
  "1174": "72",
  "1184": "72",
  "1345": "72",
  "1487": "72",
  "1607": "72",
  "1941": "72",
  "1189": "73",
  "1223": "73",
  "1403": "73",
  "1623": "73",
  "1661": "73",
  "1698": "73",
  "1931": "73",
  "1172": "74",
  "1496": "74",
  "1701": "74",
  "1761": "74",
  "1144": "75",
  "1252": "75",
  "1356": "75",
  "1380": "75",
  "1579": "75",
  "2008": "75",
  "1142": "76",
  "1398": "76",
  "1692": "76",
  "2011": "76",
  "1716": "77",
  "2019": "77",
  "2020": "77",
  "2021": "77",
  "2022": "77",
  "2026": "77",
  "1296": "78",
  "1321": "78",
  "1433": "78",
  "1561": "78",
  "1587": "78",
  "1856": "78",
  "1476": "79",
  "2023": "79",
  "2024": "79",
  "2025": "79",
  "1165": "80",
  "1423": "80",
  "1560": "80",
  "1743": "80",
  "2027": "80",
  "2028": "80",
  "2029": "80",
  "1116": "81",
  "1292": "81",
  "1730": "81",
  "1784": "81",
  "1794": "81",
  "1905": "81",
  "2017": "81",
  "2031": "81",
};
